<template>
  <AuthShell title="Accedi">
    <form @submit.prevent="submit" novalidate class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-600 mb-1" for="email">Email</label>
        <input
          id="email"
          v-model="email"
          type="email"
          autocomplete="email"
          required
          :disabled="loading"
          placeholder="nome@esempio.it"
          class="w-full px-3 py-2 text-sm text-gray-800 border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:border-onibble focus:ring-2 focus:ring-onibble transition"
        />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-600 mb-1" for="password">Password</label>
        <input
          id="password"
          v-model="password"
          type="password"
          autocomplete="current-password"
          required
          :disabled="loading"
          placeholder="••••••••"
          class="w-full px-3 py-2 text-sm text-gray-800 border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:border-onibble focus:ring-2 focus:ring-onibble transition"
        />
      </div>

      <div class="flex items-center justify-between">
        <label class="flex items-center gap-2 text-sm text-gray-600 select-none cursor-pointer">
          <input
            v-model="remember"
            type="checkbox"
            class="rounded border-gray-300 text-onibble focus:ring-onibble"
          />
          Rimani collegato
        </label>
        <router-link
          to="/forgot-password"
          class="text-sm font-medium text-onibble hover:text-ynibble transition-colors"
        >
          Password dimenticata?
        </router-link>
      </div>

      <p v-if="errorMsg" class="text-sm text-red-500">{{ errorMsg }}</p>

      <button
        type="submit"
        :disabled="loading"
        class="w-full py-2.5 px-4 text-sm font-semibold text-gray-900 bg-ynibble rounded-lg shadow-sm hover:bg-onibble focus:outline-none focus:ring-2 focus:ring-onibble disabled:opacity-60 transition-colors"
      >
        <span v-if="loading">Accesso in corso…</span>
        <span v-else>Accedi</span>
      </button>
    </form>
  </AuthShell>
</template>

<script>
import AuthShell from './AuthShell.vue';

export default {
  name: 'LoginView',
  components: { AuthShell },
  data() {
    return {
      email: '',
      password: '',
      remember: false,
      loading: false,
      errorMsg: '',
    };
  },
  methods: {
    async submit() {
      this.errorMsg = '';
      this.loading = true;
      try {
        await this.$store.dispatch('login', { username: this.email, password: this.password, remember: this.remember });
        this.$router.push('/');
      } catch (e) {
        if (e.status === 422) {
          this.errorMsg = 'Credenziali non valide. Controlla email e password.';
        } else {
          this.errorMsg = e.message || 'Errore di accesso. Riprova.';
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
